<!-- Pug Template -->
<template lang="pug">
a.ProductLine(
  :href="website"
  target="_blank"
  data-style="parallax_hover"
)
  .ProductLine__Content(
    data-layer="1"
  )
    img.ProductLine__Logo(
      :src="logo"
    )
    h3.ProductLine__Title {{ title }}

    ul.ProductLine__Terms
      li.ProductLine__Term(
        v-for="term in terms"
      ) {{ term.name }}

    button.ProductLine__Button(
      type="button"
    ) Learn More
</template>

<!-- Script -->
<script>
export default {
  props: {
    website: String,
    logo: String,
    title: String,
    terms: Array
  }
};
</script>

<!-- SCSS Style -->
<style lang="scss" scoped>
.ProductLine {
  display: block;
  width: auto;
  background: #fff;
  padding: 1rem;
  text-align: center;
  border: 1px solid #d8d8d8;
  transition: 0.4s;
	text-decoration: none;
	position: relative;
  &:hover {
		z-index: 100;
    box-shadow: 0 10px 20px rgba(0,0,0,0.2);
    transform: translateY(-5px) scale(1.05);
  }


  &__Logo {
    max-width: 100%;
		margin-bottom: 20px;
  }

  &__Title {
    font-size: 1.2rem !important;
    line-height: 1.35em !important;
		margin-bottom: 1em;
  }

  &__Terms {
    list-style: none;
    padding: 0;
    margin: 0 0 1em;
    font-size: 0.9rem;
    line-height: 1.5em;
  }

  &__Term{
    list-style: none;
    display: inline;
    padding: 0;
    line-height: 1.2em;
    color: #999;
    &:not(:last-child)::after {
      content:', ';
    }
  }

  &__Button {
    background: #224365;
    border: 0;
    font-size: 1.1rem;
    text-transform: uppercase;
    padding: 0.5em 1.5em;
    color: #fff;
    cursor: pointer;
    border-radius: 0 !important;
  }
}
</style>
